var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "flex flex-wrap" }, [
      _c("div", { staticClass: "w-full md:w-3/4 md:pr-20" }, [
        !_vm.saving
          ? _c("form", { attrs: { method: "POST" } }, [
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "title", attrs: { for: "title" } }, [
                  _vm._v("\n                        Event Title "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-sm font-sans-book" }, [
                    _vm._v(
                      "60 character maximum (including spaces). Character count: " +
                        _vm._s(_vm.characterCount)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|max:60",
                      expression: "'required|max:60'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.title,
                      expression: "form.title",
                    },
                  ],
                  attrs: { id: "title", type: "text", name: "title" },
                  domProps: { value: _vm.form.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "title", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("title"),
                        expression: "errors.has('title')",
                      },
                    ],
                    staticClass: "error text-error-red text-lg",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("title")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                _c("label", { ref: "festival", attrs: { for: "festival" } }, [
                  _vm._v("\n                        Select Event Calendar "),
                  _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.festival_id,
                        expression: "form.festival_id",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: { id: "festival", name: "festival" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "festival_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { disabled: "" }, domProps: { value: null } },
                      [_vm._v("Select an event calendar")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.currentFestivals, function (festival) {
                      return _c(
                        "option",
                        { key: festival.id, domProps: { value: festival.id } },
                        [
                          _vm._v(
                            _vm._s(festival.title) +
                              " " +
                              _vm._s(festival.datesTitle)
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.errors.has("festival")
                  ? _c(
                      "span",
                      { staticClass: "error text-error-red text-lg" },
                      [
                        _vm._v(
                          "\n                      " +
                            _vm._s(
                              _vm.errors
                                .first("festival")
                                .replaceAll("festival", "event calendar")
                            ) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-12" }, [
                !_vm.saving
                  ? _c(
                      "button",
                      {
                        staticClass: "button",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.saveEvent.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Save")]
                    )
                  : _c("span", [_vm._v("Saving...")]),
              ]),
            ])
          : _c("div", { staticClass: "text-2xl text-center mb-4" }, [
              _vm._v("Saving Event..."),
            ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "w-full md:w-1/4 border-t-5 border-black pt-3 mt-10 md:mt-2",
      },
      [
        _c("p", [
          _vm._v(
            "PLEASE NOTE: Once you submit your event for review, you cannot change the title. You can still change it while your event is a draft."
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }